/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type { BadRequestResponse } from '../model/badRequestResponse';
import type { ForbiddenResponse } from '../model/forbiddenResponse';
import type { NotFoundResponse } from '../model/notFoundResponse';
import type { OcrInvoiceInferenceResponse } from '../model/ocrInvoiceInferenceResponse';
import type { ProcessOcrInvoiceInferencesBody } from '../model/processOcrInvoiceInferencesBody';
import type { UnauthorizedResponse } from '../model/unauthorizedResponse';
import type { UnprocessableEntityResponse } from '../model/unprocessableEntityResponse';
import { useCustomClient } from '../../mutator/custom-instance';
import type { ErrorType, BodyType } from '../../mutator/custom-instance';
import { customFomDataFn } from '../../api/formData/custom-function';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

/**
 * @summary OCR Invoice Inferences
 */
export const useProcessOcrInvoiceInferencesHook = () => {
  const processOcrInvoiceInferences =
    useCustomClient<OcrInvoiceInferenceResponse>();

  return (
    processOcrInvoiceInferencesBody: BodyType<ProcessOcrInvoiceInferencesBody>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    const formData = customFomDataFn(processOcrInvoiceInferencesBody);
    return processOcrInvoiceInferences(
      {
        url: `/api/js/ocr_invoice_inferences`,
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
      },
      options
    );
  };
};

export const getProcessOcrInvoiceInferencesQueryKey = (
  processOcrInvoiceInferencesBody: ProcessOcrInvoiceInferencesBody
) => {
  return [
    `/api/js/ocr_invoice_inferences`,
    processOcrInvoiceInferencesBody,
  ] as const;
};

export const useProcessOcrInvoiceInferencesQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useProcessOcrInvoiceInferencesHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  processOcrInvoiceInferencesBody: ProcessOcrInvoiceInferencesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useProcessOcrInvoiceInferencesHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getProcessOcrInvoiceInferencesQueryKey(processOcrInvoiceInferencesBody);

  const processOcrInvoiceInferences = useProcessOcrInvoiceInferencesHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useProcessOcrInvoiceInferencesHook>>>
  > = () =>
    processOcrInvoiceInferences(
      processOcrInvoiceInferencesBody,
      requestOptions
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useProcessOcrInvoiceInferencesHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ProcessOcrInvoiceInferencesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useProcessOcrInvoiceInferencesHook>>>
>;
export type ProcessOcrInvoiceInferencesQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary OCR Invoice Inferences
 */
export const useProcessOcrInvoiceInferences = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useProcessOcrInvoiceInferencesHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  processOcrInvoiceInferencesBody: ProcessOcrInvoiceInferencesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useProcessOcrInvoiceInferencesHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useProcessOcrInvoiceInferencesQueryOptions(
    processOcrInvoiceInferencesBody,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useProcessOcrInvoiceInferencesSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useProcessOcrInvoiceInferencesHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  processOcrInvoiceInferencesBody: ProcessOcrInvoiceInferencesBody,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useProcessOcrInvoiceInferencesHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getProcessOcrInvoiceInferencesQueryKey(processOcrInvoiceInferencesBody);

  const processOcrInvoiceInferences = useProcessOcrInvoiceInferencesHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useProcessOcrInvoiceInferencesHook>>>
  > = () =>
    processOcrInvoiceInferences(
      processOcrInvoiceInferencesBody,
      requestOptions
    );

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useProcessOcrInvoiceInferencesHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ProcessOcrInvoiceInferencesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useProcessOcrInvoiceInferencesHook>>>
>;
export type ProcessOcrInvoiceInferencesSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary OCR Invoice Inferences
 */
export const useProcessOcrInvoiceInferencesSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useProcessOcrInvoiceInferencesHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  processOcrInvoiceInferencesBody: ProcessOcrInvoiceInferencesBody,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useProcessOcrInvoiceInferencesHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useProcessOcrInvoiceInferencesSuspenseQueryOptions(
    processOcrInvoiceInferencesBody,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
